export default __webpack_public_path__ + "static/media/campBrainIcon.f3b8bf09.svg";